import { TEST_STATION, TEST_CARGROUP } from '../config.js'

export default {

	OUTPUT_STATION(station) {
		if(typeof station === 'undefined') return false;

		console.log(TEST_STATION);

		const isObject = typeof station === 'object' && typeof station.station !== 'undefined',
			  isStationKey = TEST_STATION.test(station);


		console.log('isStationKey', isStationKey)
		if(!isStationKey && !isObject) return false;


		if(!isObject){
			return station; // station key
		} else if(!isStationKey) {
			throw "OUTPUT_CARGROUP required an object or an valid CARGROUP ID"
		}

		return station.station;

	},

	// 	Y-m-d H:i
	API_DATE(date){
		if(!(typeof date === 'object' && typeof date.getDate === 'function')) return false;
		//console.log('dateinput: ' + date);
		return date.getFullYear() + '-' + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes();
	},

	IS_DATE(date){
		if(!(typeof date === 'object' && typeof date.getDate === 'function')) {
			if(!typeof date === 'string') {
				return false;
			}
			date = new Date(date);
		}
		return date;
	},

	OUTPUT_DATE(date) {
		date = this.IS_DATE(date);
		if(!date) return date;

		return this.OUTPUT_DATE_ONLY_DATE(date) + ' ' + this.OUTPUT_DATE_ONLY_TIME(date);
	},

	OUTPUT_DATE_ONLY_DATE(date) {
		date = this.IS_DATE(date);
		if(!date) return date;
		return ("0" + date.getDate()).slice(-2) + '.' + ("0" + (date.getMonth() + 1)).slice(-2) + '.' + date.getFullYear();
	},

	OUTPUT_DATE_ONLY_TIME(date) {
		date = this.IS_DATE(date);
		if(!date) return date;

		return date.getHours() + ':' + (date.getMinutes() < 10 ? 0 : '') + date.getMinutes();
	},

	OUTPUT_TIME(date){
		if(!date) return date;
		return date.slice(0, 2) + ':' + date.slice(2, 4);
	},

	OUTPUT_DATE_RANGE(startdate, enddate){
		
		if(!(typeof startdate === 'object' && typeof startdate.getDate === 'function')) return false;
		if(!(typeof enddate === 'object' && typeof enddate.getDate === 'function')) return false;
		let out = "";
		// sind die Date am selben tag
		if(startdate.getFullYear() === enddate.getFullYear() && startdate.getMonth() === enddate.getMonth() && startdate.getDate() === enddate.getDate()) {
			out += this.OUTPUT_DATE_ONLY_DATE(startdate);
			out += "<br>";
			out += this.OUTPUT_DATE_ONLY_TIME(startdate) + " - " + this.OUTPUT_DATE_ONLY_TIME(enddate);
		} else {
			out += this.OUTPUT_DATE(startdate);
			out += "<br>";
			out += this.OUTPUT_DATE(enddate);
		}

		return out;
	},

	OUTPUT_CARGROUP(cargroup) {
		if(typeof cargroup === 'undefined') return false;

		console.log(TEST_CARGROUP);

		const isObject = typeof cargroup === 'object' && typeof cargroup.groupKey !== 'undefined',
			  isCarGroupKey = TEST_CARGROUP.test(cargroup);

		if(!isCarGroupKey && !isObject) return false;


		if(!isObject){
			return cargroup;
		} else if(!isCarGroupKey) {
			throw "OUTPUT_CARGROUP required an object or an valid CARGROUP ID"
		}
		return cargroup.groupKey;

	},

	OUTPUT_PRICE(price){
		if(!price) return price;
		var str = price.toString();
		var a = str.split('.');
		let first = a[0];
		let last = a[1];
		let newPrice = price;

		if (last !== undefined){
			if(parseInt(last) < 10){
				last = last + 0
			}
			newPrice = first + ',' + last;
		}else{
			newPrice = first ;
		}
		return newPrice;

		// var newstr =  str.replace(".", ",");
		// return newstr;
	},

	ROUND_PRICE(price){
		return this.OUTPUT_PRICE(price.toFixed(2));
	}
}


// WEBPACK FOOTER //
// ./src/store/orm/helpers/formater.js